import * as React from 'react';
import { sortBy } from 'lodash';

import ContentGallery from 'components/content-gallery/ContentGallery';
import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import DeliverableCustomContext from '../../deliverable-custom/context/DeliverableCustomContext';
import DeliverableCustomTriggerFooter from '../../deliverable-custom/trigger-footer/DeliverableCustomTriggerFooter';
import DeliverableCustomTriggerOverlay from '../../deliverable-custom/trigger-overlay/DeliverableCustomTriggerOverlay';
import DeliverableCustomGalleryAssetOverlay from '../../deliverable-custom/gallery-asset-overlay/DeliverableCustomGalleryAssetOverlay';
import DeliverableCustomGalleryThumbnailOverlay from '../../deliverable-custom/gallery-thumbnail-overlay/DeliverableCustomGalleryThumbnailOverlay';
import OutfitMediaToPublish from 'modules/realm-outfits/components/outfit-media-to-publish/OutfitMediaToPublish';

import { __t, applyTranslations } from 'utils/language';

import './deliverable-move-content-media.scss';

applyTranslations(require('./deliverable-move-content-media.i18n.json'));

import type {
  DeliverableAttachment,
  DeliverableCustomSelectionChangeWithId,
  RealmOutfit
} from 'types';
import type {
  ContentGalleryItem
} from 'components/content-gallery/types';

type Props = {
  attachments?: Array<ContentGalleryItem>,
  outfits?: Array<RealmOutfit>,
  onSelectionChange: DeliverableCustomSelectionChangeWithId,
  onSelectDeselectToggle: DeliverableCustomSelectionChangeWithId
};

const DeliverableMoveContentMedia = ({
  attachments,
  outfits,
  onSelectionChange,
  onSelectDeselectToggle
}: Props) => {
  const sortedAttachments = sortBy(attachments, 'id');

  const deliverableCustomContext = {
    sortedAttachments,
    onSelectionChange: (isSelected, item?: DeliverableAttachment, event?: React.MouseEvent) => {
      onSelectionChange(isSelected, item?.id, event);
    }
  };

  const tabItems = ['select_all', 'deselect_all']
    .map(type => ({
      handleClick: (event: React.SyntheticEvent<HTMLElement>) => {
        const target = event.currentTarget;
        const selectedTab = target.dataset.arg || {};

        return onSelectDeselectToggle(selectedTab === 'select_all');
      },
      handleClickArg: type,
      label: __t(`deliverable_move_content_media.global_select.${type}`)
    }));

  return (
    <div className="deliverable-move-content-media__main">
      <div className="deliverable-move-content-media__header">
        {__t('deliverable_move_content_media.header')}
      </div>
      <div className="deliverable-move-content-media__global-select-container">
        <TabsUnderlined
          items={tabItems}
          tabClassName="deliverable-move-content-media__toggle"
        />
      </div>
      <div className="deliverable-move-content-media__attachments">
        {
          attachments && (
            <DeliverableCustomContext.Provider value={deliverableCustomContext}>
              <ContentGallery
                items={deliverableCustomContext.sortedAttachments}
                itemSize="size-120"
                renderTriggerOverlay={DeliverableCustomTriggerOverlay}
                renderTriggerFooter={DeliverableCustomTriggerFooter}
                renderGalleryAssetOverlay={DeliverableCustomGalleryAssetOverlay}
                renderGalleryThumbnailOverlay={DeliverableCustomGalleryThumbnailOverlay}
              />
            </DeliverableCustomContext.Provider>
          )
        }
        {
          outfits && (
            <div className="deliverable-move-content-media__outfits">
              {
                 outfits.map((outfit, index) => (
                   <OutfitMediaToPublish
                     key={outfit.id}
                     isForBrand
                     outfit={outfit}
                     onSelectMoveOutfitToAnotherDeliverable={(item, isSelected) => onSelectionChange(isSelected, item.id)}
                     outfitPosition={index}
                   />
                 ))
              }
            </div>
          )
        }

      </div>
    </div>
  );
};

export default DeliverableMoveContentMedia;
